import React from 'react';
import * as Styles from './Styles.css';

export default function MaterialIcon({ type, size, rotate, disabled }) {
  if (!type)
    return false;
  return <i style={{ fontSize: size, transform: `rotate(${rotate})`, maxWidth: size }}
    className={`${disabled ? Styles.disabled : ''} ${'material-icons'}`} >{type}</i>
}